import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../shared/pagination-model';

@JsonObject('ImportStockLocationFilters')
export class ImportStockLocationFilters extends Pagination {
  @JsonProperty('distrName', String, true) code: string = undefined;
}
